module.exports = __webpack_public_path__ + "img/yiyangjeihe_image_ylms.ae04b3df.png";